// Portfolio Administration v1.0 PR 5 — shared empty-state card for
// detail-page tabs whose data model is deferred to a follow-up module
// (Vendor Program v3.0 in particular). Keeps the tab strip honest:
// users land on a real surface with an explanation, not a 404.

import { Card } from "@/design-system/components/ui";
import type { ReactNode } from "react";

export interface EmptyTabCardProps {
  title: string;
  description: ReactNode;
  testId?: string;
}

export function EmptyTabCard({ title, description, testId }: EmptyTabCardProps) {
  return (
    <Card
      className="flex flex-col gap-space-2 items-start"
      data-testid={testId}
    >
      <h3 className="font-display font-bold text-h3 m-0">{title}</h3>
      <p className="text-small text-gray-mid italic m-0">{description}</p>
    </Card>
  );
}
